export const consumerKey = "1ul00oduicbn6l0lmgjq0ivb58hn39ry";
export const consumerSecret = "rbym8kwjnrf58bz8h7kspt92dqwqeiwu";
export const accessToken = "psvk07j2aul9cpjsumbnze3n3h3cls58";
export const accessTokenSecret = "difaq0i0f77q59zs2fngauj8ueud0ode";
